<template>
<div>
  <v-btn absolute dark fab top right color="primary" style="top:10px;" @click="extraTimeDialog = true">
      <v-icon color="black">add</v-icon>
  </v-btn>
  <extraTimeForm :dialog="extraTimeDialog" @setDialog="extraTimeDialog = $event"
  :editedIndex="editedIndex" 
  @setEditIndex="editedIndex = $event"/>
  <v-data-table :headers="headers" :items="addons" :pagination.sync="pagination">
    <template slot="items" slot-scope="props">
      <td>{{ props.item.num }}</td>
      <td class="text-xs-left">{{ props.item.name }}</td>
      <td class="text-xs-center">{{ props.item.time }} น.</td>
      <td class="text-xs-center">{{ props.item.status }}</td>
      <td class="justify-center layout px-0">
        <v-tooltip top>
            <v-btn icon slot="activator" @click="editExtraTime()">
            <v-icon small>
            edit
            </v-icon>
            </v-btn>
            <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
            <v-btn icon slot="activator">
            <v-icon small>
            delete
            </v-icon>
            </v-btn>
            <span>Delete</span>
        </v-tooltip>
        <v-switch v-model="switch1" color="primary" style="max-width:50px;margin-top:11px;"></v-switch>
      </td>
    </template>
  </v-data-table>
  <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
  </div>  -->
</div>
</template>

<script>
import extraTimeForm from './ExtraTimeDialogForm'
export default {
    components: {
        extraTimeForm
    },
  data() {
    return {
       extraTimeDialog: false,
       dialog: false,
       editedIndex: -1,
       switch1: true,
       pagination: {
        page : 1,
        rowsPerPage : 10
       },
      headers: [
        { text: "#",value: "num", align: "center",sortable: false},
        { text: "Extra time name TH", value: "name", align: "center", sortable: false },
        { text: "Time", value: "time", align: "center", sortable: false },
        { text: "Status", value: "status", align: "center", sortable: false },
        { text: "Action", value: "action", align: "center", sortable: false }
      ],
      addons: [
        {
          num: "1",
          name: "ค่าบริการเพิ่ม ช่วงที่1",
          time: "21.00 - 23.59",
          status: "Active",
          action: ""
        },
        {
          num: "2",
          name: "ค่าบริการเพิ่ม ช่วงที่2",
          time: "00.00 - 06.59",
          status: "Inactive",
          action: ""
        }
      ]
    };
  },
   methods: {
      editExtraTime() {
            this.extraTimeDialog = true;
            this.editedIndex = 1;
            }
  },
  computed: {
    pages () {
        // this.pagination.totalItems = this.product_list.length
        if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
};
</script>